import React from 'react';
import { AppContainer } from '../components/AppContainer';

import { useIsMobile } from '../hooks';
import AdmView from '../components/AdmView';

export const Admin = (): JSX.Element => {
	const isMobile = useIsMobile();

	return (
		<AppContainer
			sx={{
				p: isMobile ? 2 : 4,
			}}
		>
			<AdmView />
		</AppContainer>
	);
};
